/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { languageFromNavigator } from "./languageFromNavigator";
import { languageSupport, languageSupportData } from "./languageDetails";

export async function languageRequestParam() {
  const language = await languageFromNavigator();
  const lang = (await languageSupport()).includes(language) ? language : "en";
  return (
    languageSupportData.find((item) => item.id === lang)?.obj ??
    languageSupportData[0].obj
  );
}
